import axios from "axios"
import configs from "./configs"
import { Region } from "./types"


const cache = {
    cities: undefined as Region[]|undefined,
    provinces: undefined as Region[]|undefined,
} as {
    cities:Region[]|undefined,
    provinces:Region[]|undefined,
    districts:Region[]|undefined,
    all:Region[]|undefined
}

export const getRegionId = async (regionGroup:"cities"|"provinces", name:string) => {
    return (await getRegionIdByName(regionGroup, name)) 
    || (await getRegionIdByShortName(regionGroup, name))
}
export const getRegionIdByName = async (regionGroup:"cities"|"provinces", name:string) => {
    const regions = await getRegions(regionGroup)
    const region = regions.find(x=>x.name == name)
    if (!!region){
        return region.id
    }
    return null
}
export const getRegionIdByShortName = async (regionGroup:"cities"|"provinces", name:string) => {
    const regions = await getRegions(regionGroup)
    const region = regions.find(x=>x.short_name == name)
    if (!!region){
        return region.id
    }
    return null
}

export const getRegions = async (
    _regionGroup:"cities"|"provinces"|"city"|"province"|"all",
):Promise<Region[]> => {

    let regionGroup = _regionGroup
    if (regionGroup == "city"){
        regionGroup = "cities"
    }else if (regionGroup == "province"){
        regionGroup = "provinces"
    }

    try{
        if (cache[regionGroup]){
            return cache[regionGroup]
        }

        const res = await axios.get(configs.urlPrefix + '/common/regions')
        console.log('getRegions res ' ,regionGroup , res)
        if (res.data.code == 0){
            const cities = res.data.payload.filter(x=>x.region_type == "城市")
            const provinces = res.data.payload.filter(x=>x.region_type == "省份")
            const districts = res.data.payload.filter(x=>x.region_type == "区县")
            cache.cities = cities
            cache.provinces = provinces
            cache.districts = districts
            cache.all = res.data.payload
            return cache[regionGroup]
        }else{
            console.log('getRegions err 01', res.data)
            return [] as Region[]
        }

    }catch(e){
        console.log('getRegions err', e)
        return [] as Region[]
    }
}